import PropTypes from "prop-types";
import React from "react";
import Button from "../components/Button";
import Modal from "../components/Modal";

const PolicyLimitWarningModal = ({ handleClose, handleConfirm }) => (
  <Modal handleClose={handleClose} headingText="Warning: Policy limit threshold met">
    <div className="p-6 w-160">
      <p className="mb-6">
        If you change the policy limit to another Business Level, the deductible and sublimits
        specified in Step 4 will be lost.
      </p>

      <p className="mb-6">
        You will need to contact the broker for the customer’s sublimit and deductible selection.
      </p>

      <p className="mb-6">Are you sure you want to continue?</p>

      <div className="flex">
        <Button onClick={handleClose} className="mr-4">
          No, cancel and go back
        </Button>

        <Button kind="primary" onClick={handleConfirm}>
          Yes, continue
        </Button>
      </div>
    </div>
  </Modal>
);

PolicyLimitWarningModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default PolicyLimitWarningModal;
